import { Dayjs } from "dayjs";
import { Amounts } from "./Amounts";
import { Conversation } from "./Conversation";
import { Form } from "./Form";
import { LineItem } from "./LineItem";
import { Note } from "./Note";
import { PaymentReminder } from "./PaymentReminder";
// eslint-disable-next-line import/no-cycle
import { PurchaseItem } from "./PurchaseItem";
import { BookingEngineSource, Source } from "./Source";
import { Tag } from "./Tag";
import { Telemetry } from "./Telemetry";
import { Traveler } from "./Traveler";

export interface Purchase {
    id: ID;
    conversation: Conversation;
    customerName: string;
    customerEmail: string;
    phone: string;
    lineItems: LineItem[];
    items: PurchaseItem[];
    currency: string;
    amount: number;
    /** Only serialized for Xola admins; `traveler` includes amounts the seller never sees. */
    amounts?: Amounts;
    dueNow: number;
    payNow?: number;
    balance: number;
    notes: Note[];
    organizer?: { id: ID };
    paymentReminders?: PaymentReminder[];
    tags?: Tag[];
    createdAt: Dayjs;
    createdBy: { id: ID };
    seller: { id: ID };
    travelers: Traveler[];
    form?: Form;
    splitPayment: { enabled: boolean };
    status: PurchaseStatus;
    object: PurchaseObject;
    notifyAt?: Dayjs;
    source: Source | BookingEngineSource;
    affiliatePayment?: number;
    referenceId?: string;
    migratedAt?: Dayjs;
    telemetry?: Telemetry;
    partnerSeller?: { id: ID };
    partner?: {
        id: ID;
        object: string;
        viewPurchases?: boolean;
        editPurchases?: boolean;
    };
}

export enum PurchaseStatus {
    COMMITTED = "committed",
    DRAFT = "draft",
    HOLD = "hold",
}

export enum PurchaseObject {
    PURCHASE = "purchase",
    ABANDON = "abandoned_purchase",
    WAITLIST = "waitlist_purchase",
}
